import { Eye, Users, Sparkles } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const points = [
  {
    icon: Eye,
    title: "Un effet miroir",
    desc: "Ce qui est difficile à percevoir seul devient visible à travers le groupe.",
  },
  {
    icon: Users,
    title: "Une dynamique collective",
    desc: "La présence des autres participants permet de représenter des places et des liens.",
  },
  {
    icon: Sparkles,
    title: "Une lecture plus large",
    desc: "On accède à des informations qui ne se laissent pas atteindre par la seule pensée.",
  },
];

export default function WhyGroup() {
  return (
    <section
      data-testid="ateliers-why"
      className="py-24 md:py-32 bg-[#FAF7F8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="max-w-3xl">
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — Le groupe comme outil
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
              Pourquoi travailler en groupe
            </h2>
            <p className="mt-6 text-lg text-[#5F6170] leading-relaxed">
              Le groupe agit comme un miroir. Il permet de voir ce qui est difficile
              à percevoir seul.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {points.map(({ icon: Icon, title, desc }, i) => (
            <Reveal key={title} delay={i * 0.08}>
              <div
                data-testid={`ateliers-why-card-${i}`}
                className="h-full p-8 bg-white rounded-3xl border border-[#DDD7E2] hover:border-[#C98FA3] hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-full bg-[#F3EEF4] flex items-center justify-center">
                  <Icon className="w-5 h-5 text-[#3A2E6E]" />
                </div>
                <h3 className="font-serif-display text-2xl mt-5 text-[#1E1E2A]">{title}</h3>
                <p className="mt-3 text-sm text-[#5F6170] leading-relaxed">{desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
